// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2e61a1ac","239":"da075f5c","453":"c65542c3","667":"ab847d1a"}[chunkId] + ".chunk.js";
};